<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M22.9166 6.25033V18.7503C22.9166 19.3232 22.7126 19.8137 22.3046 20.2217C21.8966 20.6297 21.4062 20.8337 20.8333 20.8337H4.16659C3.59367 20.8337 3.10322 20.6297 2.69523 20.2217C2.28725 19.8137 2.08325 19.3232 2.08325 18.7503V6.25033C2.08325 5.67741 2.28725 5.18696 2.69523 4.77897C3.10322 4.37099 3.59367 4.16699 4.16659 4.16699H20.8333C21.4062 4.16699 21.8966 4.37099 22.3046 4.77897C22.7126 5.18696 22.9166 5.67741 22.9166 6.25033ZM4.16659 8.33366H20.8333V6.25033H4.16659V8.33366ZM4.16659 12.5003V18.7503H20.8333V12.5003H4.16659Z"
      fill="currentColor"
    />
  </svg>
</template>
